<script>
	import { storyblokEditable } from '@storyblok/svelte';
	import MetaBlock from '$lib/components/Storyblok/MetaBlock.svelte';
	import Breadcrumbs from '$lib/components/Breadcrumbs.svelte';
	import FAQSection from '$lib/components/FAQ/FAQSection.svelte';
	import { getTranslate } from '@tolgee/svelte';
	import DisclosureWrapper from '$lib/components/FAQ/DisclosureWrapper.svelte';
	import { extractRawLdJsonScript } from '$lib/utils/faq';

	export let data;

	$: content = data.story.content;

	const { t } = getTranslate();

	$: toStructured = content.body
		.map((body) =>
			body.entries
				.map(({ entries }) => {
					return entries.map((entry) => {
						return {
							question: entry.title,
							answer: entry.seo_answer
						};
					});
				})
				.flat()
		)
		.flat();
</script>

<svelte:head>
	{@html extractRawLdJsonScript(toStructured)}
</svelte:head>

<div class="w-full" use:storyblokEditable={content}>
	<MetaBlock
		{content}
		defaults={{
			description: 'seo.description.faq',
			meta_keywords: 'seo.meta_keywords.faq',
			title: 'seo.title.faq'
		}}
	/>
	<header class="w-full box-x-wrapper">
		<Breadcrumbs class="mt-4 mb-11" />
	</header>

	<main
		class="relative w-full box-x-wrapper flex flex-col md:grid md:grid-cols-3 grid-cols-1 gap-5"
	>
		<h1 class="col-span-3 order-1 text-h-40 md:text-h-72 md:mb-8">FAQ</h1>
		<div class="md:col-span-2 order-3 md:order-2">
			{#each content?.body || [] as section}
				<FAQSection {section} />
			{/each}
		</div>
		<div class="pr-wrapper order-2 md:order-3">
			<DisclosureWrapper
				class="md:sticky mb-8 md:mb-0 md:top-48 lg:top-36 md:right-[5%] "
				content={content.body.map((section) => ({
					headline: section.title,
					sublines: section.entries.map((e) => ({
						href: `${section.title + e.title}`,
						title: e.title
					}))
				}))}
				headline={$t('faq.disclosure.headline')}
			/>
		</div>
	</main>
</div>
